import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Option, Pax } from '../interfaces/button-menu.interface';

type PaxKey = keyof Pax;
const asset = (p: string) => new URL(p, import.meta.url).toString();

@Component({
  selector: 'app-button-menu',
  standalone: true,
  imports: [NgClass],
  templateUrl: './button-menu.component.html',
  styleUrl: './button-menu.component.css',
})
export class ButtonMenuComponent implements OnInit, OnChanges {
  @Output() paxChange = new EventEmitter<Pax>();
  @Output() optionSelected = new EventEmitter<Option>();

  @Input() icon = 'person';
  @Input() text = 'text';
  @Input() options: Option[] = [];
  @Input() selectedOption!: Option | null;
  @Input() isPax = false;
  @Input() pax: Pax = {
    adults: 1,
    children: 0,
    infants: 0,
  };
  totalPax = 1;
  errorPaxs = false;

  paxTypes: { key: PaxKey; label: string; description: string; min: number }[] =
    [
      { key: 'adults', label: 'Adulto', description: '+ 12 años', min: 1 },
      { key: 'children', label: 'Niños', description: '2-11 años', min: 0 },
      { key: 'infants', label: 'Bebés', description: '< 2 años', min: 0 },
    ];

  isOpen = false;
  add = asset('./icons/add.svg');
  minus = asset('./icons/minus.svg');
  minusDisabled = asset('./icons/minus_disabled.svg');
  addDisabled = asset('./icons/add_disabled.svg');

  ngOnInit() {
    this.totalPax = this.pax.adults + this.pax.children + this.pax.infants || 1;
    if (this.selectedOption?.label) this.text = this.selectedOption.label;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedOption'] && changes['selectedOption'].currentValue) {
      const newOption = changes['selectedOption'].currentValue as Option;
      this.text = newOption.label;
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: Option) {
    this.selectedOption = option;
    this.text = option.label;
    this.isOpen = false;
    this.optionSelected.emit(option);
  }

  handlerPax(action: 'increment' | 'decrement', type: PaxKey) {
    switch (type) {
      case 'adults':
        if (action === 'increment') {
          this.pax.adults++;
        }
        if (action === 'decrement') {
          if (this.pax.adults > 1) {
            this.pax.adults--;
          }
        }
        break;
      case 'children':
        if (action === 'increment') {
          this.pax.children++;
        }
        if (action === 'decrement') {
          if (this.pax.children > 0) {
            this.pax.children--;
          }
        }
        break;
      case 'infants':
        if (action === 'increment') {
          this.pax.infants++;
        }
        if (action === 'decrement') {
          if (this.pax.infants > 0) {
            this.pax.infants--;
          }
        }
        break;
    }
    this.errorPaxs = this.pax.infants > this.pax.adults;
    this.totalPax = this.pax.adults + this.pax.children + this.pax.infants || 1;
    this.paxChange.emit(this.pax);
  }
}
